const isAutoAdded = createdBy => createdBy === 'AUTOMATION SERVICE' || 'dyzio-campaign-automation';
const isStory = type => type === 'stories';

module.exports = { isAutoAdded, isStory };



/** WEBPACK FOOTER **
 ** ./src/utils/automation-utils.js
 **/